import gatsbyWrapRoot from './gatsby-wrap-root';
import gatsbyWrapPage from './gatsby-wrap-page';

export const wrapRootElement = gatsbyWrapRoot;
export const wrapPageElement = gatsbyWrapPage;